import { MenuItem, Select } from '@mui/material'
import { useMemo, useState } from 'react'
import { EOp, FilterModelText, Nullish } from 'types'

export function usePortalFilter() {
  const [portalValue, setPortalValue] = useState<string>('')

  const portalFilterValue: Nullish<{ portal: FilterModelText }> = useMemo(() => {
    if (portalValue) {
      return {
        portal: {
          type: 'text',
          op: EOp.equals,
          value: portalValue,
        },
      }
    }

    return null
  }, [portalValue])

  const PortalFilter = useMemo(() => {
    return (
      <Select
        value={portalValue}
        onChange={(e) => setPortalValue(e.target.value)}
        displayEmpty
        size="small"
        sx={{ minWidth: 150 }}
      >
        <MenuItem value="">All Portals</MenuItem>
        <MenuItem value="trainee">Trainee</MenuItem>
        <MenuItem value="caregiver">Family</MenuItem>
      </Select>
    )
  }, [portalValue])

  return { PortalFilter, portalFilterValue }
}
